import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import RouteConfig from '../config/appRoute/RouteConfig';
import { FUNCTIONS } from '../constants/APDConstants';
import History from '../components/time-clock/History'
import PastWorkHistory from '../components/time-clock/PastWorkHistory'
import SapHistory from '../components/time-clock/SapHistory'
import MeaBoundary from '../components/time-clock/MeaBoundary'

function ClockInOutManagement({ authenRdc }) {
    const router = [];
    authenRdc.profile.functions.forEach((func) => {
        switch (func.functionId) {
            case FUNCTIONS.CLOCKINOUT_HISTORY.id:
                router.push(
                    <Route
                        key={RouteConfig.CLOCKINOUT_HISTORY}
                        path={RouteConfig.CLOCKINOUT_HISTORY}
                        component={History}
                    />
                );
                break;
            case FUNCTIONS.CLOCKINOUT_PAST_WORK_HISTORY.id:
                router.push(
                    <Route
                        key={RouteConfig.CLOCKINOUT_PAST_WORK_HISTORY}
                        path={RouteConfig.CLOCKINOUT_PAST_WORK_HISTORY}
                        component={PastWorkHistory}
                    />
                );
                break;
            case FUNCTIONS.CLOCKINOUT_SAP_HISTORY.id:
                router.push(
                    <Route
                        key={RouteConfig.CLOCKINOUT_SAP_HISTORY}
                        path={RouteConfig.CLOCKINOUT_SAP_HISTORY}
                        component={SapHistory}
                    />
                );
                break;
            case FUNCTIONS.MEA_BOUNDARY.id:
                router.push(
                    <Route
                        key={RouteConfig.MEA_BOUNDARY}
                        path={RouteConfig.MEA_BOUNDARY}
                        component={MeaBoundary}
                    />
                );
                break;
            default:
                break;
        }
    });

    return (
        <Switch>
            {router}
            <Route
                path={RouteConfig.CLOCKINOUT_MANAGEMENT}
                render={() => {
                    const pathRedirect = router.length ? router[0].key : '/';
                    return <Redirect to={pathRedirect} />;
                }}
            />
        </Switch>
    );
}

const mapStateToProps = (state) => ({
    authenRdc: state.authen,
});

export default connect(mapStateToProps)(ClockInOutManagement);
